import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Twitter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08 20A11.07 11.07 0 0019.52 9 8.09 8.09 0 0021 6.16a.44.44 0 00-.62-.51 1.88 1.88 0 01-2.16-.38 3.89 3.89 0 00-5.58-.17A4.13 4.13 0 0011.49 9C8.14 9.2 5.84 7.61 4 5.43a.43.43 0 00-.75.24 9.68 9.68 0 004.6 10.05A6.73 6.73 0 013.38 18a.45.45 0 00-.14.84A11 11 0 008.08 20",
    "data-name": "twitter"
  })));
});
Twitter.displayName = 'Twitter';
export var TwitterDimensions = {
  height: 24,
  width: 24
};